/*
 * @Author:
 * @Description:
 * @Date: 2024-09-13 16:52:58
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/api/index.js
 */
import http from '@/utils/http';

export function saveMerchantInfo(data) {
  return http.post('/merLogin/saveMerchantInfo', data);
}
export function getMerchantInfo() {
  return http.get('/merLogin/getMerchantInfo');
}
